import React from "react";

import Wrapper from "./Wrapper";
import Input from "./Input";

const Checkbox = ({ ...props, children }) => {
  return (
    <Wrapper {...props}>
      <Input type="checkbox" checked={props.checked} />
      {children}
    </Wrapper>
  );
};

export default Checkbox;
